import keyMirror from 'react-utils/keyMirror';
export const QuestionTypes = keyMirror({
  MULTIPLE_CHOICE_SELECT_ONE: null,
  MULTIPLE_CHOICE_SELECT_MANY: null
});
export const QuizTypes = keyMirror({
  INDIVIDUAL_VALIDATION: null,
  WHOLE_VALIDATION: null
});